import React from "react";
import { Link } from "react-router-dom";
import { Search, Radio } from "semantic-ui-react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
const ShipmentHeader = (props) => {
  const { t } = props;
  return (
    <React.Fragment>
      <div id="dispatch_bar">
        <div className="container-fluid dip_bar">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-flex justify-content-between">
                <label className="mt-2 font-weight-normal">{props.title}</label>
                <div className="form-inline">
                  <Radio
                    toggle
                    className="mr-1"
                    name="gridView"
                    checked={props.toggle}
                    onChange={props.toggleView}
                    hidden={props.hidden}
                  />
                  <Search
                    size="mini"
                    className="mr-2 ml-2"
                    input={{ icon: "search", iconPosition: "left" }}
                    placeholder={t("action_button.search") || "Search"}
                  />
                  {props.permissions.SHIPMENT.CREATE == true ? (
                    <Link
                      to={props.LinkName}
                      className="text-decoration-none w3-button w3-hover-border-black w3-hover-white w3-border-light-grey w3-small ml-1 w3-border w3-round"
                    >
                      <i className="fas fa-plus"></i>{" "}
                      {t("action_button.new") || "New"}
                    </Link>
                  ) : (
                    null
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
export default connect(mapStateToProps)(translate("shipment")(ShipmentHeader));
